export const messages = {
  en: {
    aAccessControl: {
      search: {
        title: 'Search Conditions',
        machineCode: 'Please enter device code',
        machineName: 'Please enter device name',
        locationName: 'Please enter location name'
      },
      list: {
        title: 'Access Control Information'
      },
      table: {
        communityName: 'Community Name',
        machineCode: 'Device Code',
        machineName: 'Device Name',
        machineIp: 'IP',
        machineMac: 'Mac',
        promptSwitch: 'Prompt Switch',
        direction: 'Direction',
        implBean: 'Manufacturer',
        locationName: 'Location',
        stateName: 'Online Status',
        heartbeatTime: 'Heartbeat Time'
      },
      direction: {
        in: 'In',
        out: 'Out'
      },
      fetchError: 'Failed to get access control list'
    }
  },
  zh: {
    aAccessControl: {
      search: {
        title: '查询条件',
        machineCode: '请输入设备编码',
        machineName: '请输入设备名称',
        locationName: '请输入位置名称'
      },
      list: {
        title: '门禁信息'
      },
      table: {
        communityName: '园区名称',
        machineCode: '门禁编码',
        machineName: '门禁名称',
        machineIp: 'IP',
        machineMac: 'Mac',
        promptSwitch: '开门提示',
        direction: '方向',
        implBean: '厂家',
        locationName: '位置',
        stateName: '在线',
        heartbeatTime: '心跳时间'
      },
      direction: {
        in: '进',
        out: '出'
      },
fetchError: '获取门禁列表失败'
    }
  },
  'zh-TW': {
    aAccessControl: {
      search: {
        title: '查詢條件',
        machineCode: '請輸入設備編碼',
        machineName: '請輸入設備名稱',
        locationName: '請輸入位置名稱'
      },
      list: {
        title: '門禁資訊'
      },
      table: {
        communityName: '小區名稱',
        machineCode: '門禁編碼',
        machineName: '門禁名稱',
        machineIp: 'IP',
        machineMac: 'Mac',
        promptSwitch: '開門提示',
        direction: '方向',
        implBean: '廠家',
        locationName: '位置',
        stateName: '線上',
        heartbeatTime: '心跳時間'
      },
      direction: {
        in: '進',
        out: '出'
      },
      fetchError: '獲取門禁列表失敗'
    }
  }
}